import { useForm } from 'react-hook-form';
import { PasswordInput, Button as SubmitButton } from '../Form';
import { useEffect, useState } from 'react';
import { BalanceIcon } from '../../assets/svg/StatusIcon';
import { CloseIcon } from '../../assets/svg/MenuIcons';
import Button from '../Button';
import { encryptAES, RootState } from '@rb-serve-app/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  activateCardRequest,
  changePinRequest,
  resetChangePinState,
} from '@rb-serve-app/core';

import CommanToolTip from '../CommanToolTip';
import CommanModal from '../CommanModal';
import InlineError from '../ErrorComponents/InlineError';
import SuccessModel from '../SuccessModel';
import { useRecaptchaToken } from '@rb-serve-app/core';

const ChangePinAndActivateCardModal = ({
  isOpenChangePinModal,
  setIsOpenChangePinModal,
  currentModal,
}: any) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    resetField,
    formState: { errors, isValid },
  } = useForm<{ newPin: string; confirmPin: string }>({
    mode: 'onChange',
  });
  const dispatch = useDispatch();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isApiError, setIsApiError] = useState(false);
  type InactivityError = {
    status?: string | number | undefined;
    detail: string;
    title?: string; // Optional property
  };
  const test = useSelector((state: RootState) => state.popup);
  const getRecaptchaToken = useRecaptchaToken();
  console.log('cuurentModal', currentModal);
  const [inactivityErrorMsg, setInactivityErrorMsg] =
    useState<InactivityError | null>(null);
  useEffect(() => {
    setInactivityErrorMsg(null);
    dispatch(resetChangePinState());
  }, []);
  const {
    loading,
    activatePinSuccess,
    activatePinError,
    changePinSuccess,
    changePinError,
  } = useSelector((state: RootState) => state.changePin);
  const newPinValue = watch('newPin');
  useEffect(() => {
    setInactivityErrorMsg(null);
  }, [newPinValue]);
  const { availableCards, accountId, customerId, userName, accountDetails } =
    useSelector((state: RootState) => state.user);
  const cardlist = availableCards;
  const primaryIndex = cardlist.findIndex(
    (item: any) => item.customerType === 'PRIMARY'
  );
  const selectedCard = cardlist[primaryIndex];
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );
  const { entries, assets } = contentfulData;
  const contentfulApiErrors = entries?.rb_error?.activateCardAndChangePin;
  useEffect(() => {
    let customErr: InactivityError | null = null;

    if (currentModal === 'change-pin' && changePinError) {
      if ([404, 500].includes(Number(changePinError.status))) {
        setIsOpenChangePinModal(false);
        customErr = {
          status: changePinError.status,
          title: entries?.rb_change_pin?.webChangeActivateCardApi?.title,
          detail: entries?.rb_change_pin?.webChangeActivateCardApi?.description,
        };
      } else if (changePinError.status === '403') {
        customErr = {
          status: changePinError.status,
          title: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.title,
          detail: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.detail,
        };
      } else {
        customErr = {
          status: changePinError.status,
          title: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.title,
          detail: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.detail,
        };
      }
    } else if (currentModal === 'activate-card' && activatePinError) {
      if ([404, 500].includes(Number(activatePinError.status))) {
        setIsOpenChangePinModal(false);
        customErr = {
          status: activatePinError.status,
          title: entries?.rb_change_pin?.webChangeActivateCardApi?.title,
          detail: entries?.rb_change_pin?.webChangeActivateCardApi?.description,
        };
      } else if (activatePinError.status === '403') {
        customErr = {
          status: activatePinError.status,
          title: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.title,
          detail: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.detail,
        };
      } else if (
        activatePinError.status === '422' &&
        activatePinError.detail === 'Validation failed'
      ) {
        customErr = {
          status: activatePinError.status,
          title: contentfulApiErrors?.INVALID_PIN?.title,
          detail: contentfulApiErrors?.INVALID_PIN?.detail,
        };
      } else if (
        activatePinError.status === '422' &&
        activatePinError.detail === 'PIN set up and activate failed.'
      ) {
        customErr = {
          status: activatePinError.status,
          title: contentfulApiErrors?.PIN_ACTIVATE_FAILED?.title,
          detail: contentfulApiErrors?.PIN_ACTIVATE_FAILED?.detail,
        };
      } else if (
        activatePinError.status === '401' &&
        activatePinError.detail ===
          'PIN changed successfully but Card activation failed.'
      ) {
        customErr = {
          status: activatePinError.status,
          title: contentfulApiErrors?.PIN_SUCCESS_ACTIVATE_FAILED?.title,
          detail: contentfulApiErrors?.PIN_SUCCESS_ACTIVATE_FAILED?.detail,
        };
      } else {
        customErr = {
          status: activatePinError.status,
          title: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.title,
          detail: contentfulApiErrors?.INVALID_ACCOUNT_STATUS?.detail,
        };
      }
    }
    setInactivityErrorMsg(customErr);
  }, [changePinError, activatePinError, currentModal, contentfulApiErrors]);
  console.log(
    'changePinError',
    changePinError,
    activatePinError,
    inactivityErrorMsg
  );
  const updatePin = async (data: { newPin: string; confirmPin: string }) => {
    console.log('updateUserPin');

    let token: string | null = null;
    if (currentModal === 'activate-card') {
      token = await getRecaptchaToken('activate_pin');
    } else {
      token = await getRecaptchaToken('change_pin');
    }

    try {
      if (data.newPin) {
        const payload = {
          accountId: accountId,
          customerId: customerId,
          requestBody: {
            pin: encryptAES(data.newPin),
            recaptchaToken: token,
          },
        };

        // Call API or use payload here
        console.log('Payload ready:', payload);
        if (currentModal == 'activate-card') {
          dispatch(activateCardRequest(payload));
        } else {
          dispatch(changePinRequest(payload));
        }
      }
    } catch (error) {
      console.log('Error updating PIN:', error);
    }
  };
  useEffect(() => {
    console.log('activatePinSuccess##', activatePinSuccess);
    if (
      (activatePinSuccess !== null &&
        activatePinSuccess?.status === 'APPROVED') ||
      (changePinSuccess !== null && changePinSuccess?.statusCode === '200')
    ) {
      setIsSuccess(true);
      resetField('newPin');
      resetField('confirmPin');
    }
  }, [loading, changePinSuccess, activatePinSuccess]);

  const [isTooltip, setIsTooltip] = useState(false);
  const onCloseIconClick = () => {
    setIsOpenChangePinModal(false);
  };
  const contents = entries?.rb_change_pin;
  const [isDisabled, setIsDisabled] = useState(true);

  const {
    rb_change_pin: { changePin },
  } = entries;
  const onToggle = () => {
    setIsTooltip(!isTooltip);
  };
  const updateAfterSuccessPopUp = async () => {
    setIsSuccess(false);
    setIsApiError(false);
    dispatch(resetChangePinState());
    onCloseIconClick();
    if (currentModal === 'activate-card') {
      window.location.reload();
    }
  };

  if (!isOpenChangePinModal) return null;
  return (
    <>
      {isSuccess || isApiError ? (
        <SuccessModel
          successIcon={isSuccess ? true : false}
          isOpen={true}
          closeModal={() => {
            updateAfterSuccessPopUp();
          }}
          title={
            isSuccess
              ? currentModal === 'activate-card'
                ? changePin?.success?.title
                : changePin?.updatedPin?.title
              : inactivityErrorMsg &&
                [404, 500, 403, 422, 401].includes(
                  Number(inactivityErrorMsg.status)
                ) &&
                inactivityErrorMsg?.title
          }
          subTitle={
            isSuccess ? (
              currentModal === 'activate-card' ? (
                <>
                  {changePin?.success?.description}
                  {activatePinSuccess?.confirmationNumber && (
                    <p className="mt-2 text-[#1F1F1F] text-[16px] font-[500] leading-[20px] tracking-[-0.051px] text-center">
                      <span className="">
                        {changePin?.success?.confirmationNumber ||
                          'Confirmation number'}
                        :
                      </span>{' '}
                      {activatePinSuccess?.confirmationNumber}
                    </p>
                  )}
                </>
              ) : (
                changePin?.updatedPin?.description
              )
            ) : (
              inactivityErrorMsg &&
              [404, 500, 403, 422, 401].includes(
                Number(inactivityErrorMsg.status)
              ) &&
              inactivityErrorMsg?.detail
            )
          }
        />
      ) : (
        <div
          //className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 min-h-screen"
          aria-labelledby="changePinModal"
          aria-modal="true"
          role="dialog"
        >
          <div
            id="changePinModal"
            className="xl:w-auto lg:w-[80%] relative md:w-[70%] w-full md:max-h-[88vh] md:h-auto max-h-full h-full overflow-y-auto bg-white   md:rounded-[15px] rounded-none shadow-lg  md:p-[40px] p-[15px]"
            role="alert"
          >
            <form
              onSubmit={handleSubmit(updatePin)}
              className="max-w-md mx-auto p-[10px] bg-white max-h-full h-full overflow-y-auto "
            >
              <div className="flex flex-row justify-center gap-2 items-center">
                <h2
                  aria-label={changePin?.selectNewPin}
                  className="text-2xl font-[600] text-gray-800 mb-2"
                >
                  {changePin?.selectNewPin}
                </h2>
                <div className=" relative group tooltip-container">
                  <span className="inline-block cursor-pointer">
                    <BalanceIcon
                      aria-label="balanceIcon"
                      fill={'#da291c'}
                      width="18"
                      height="18"
                    />
                  </span>

                  <div
                    className={`absolute mb-1 w-[350px] bg-white text-black text-xs rounded shadow-md border border-light-gray-border font-[400]  z-[999] top-[28px] p-[20px] h-auto hidden group-hover:block right-1/2 translate-x-[23%] translate-y-[1%]`}
                    //style={{ left: '-280px' }}
                  >
                    <span className="text-[#DA271C] font-[500] text-text15 leading-5">
                      {changePin?.tooltip?.title}
                    </span>

                    <ul className="list-disc pl-5 text-gray-700 text-base font-normal leading-10 mt-[5px]">
                      {changePin?.tooltip?.descriptionWeb
                        ?.split('\n•')
                        .map((item: any, index: number) => (
                          <li
                            key={index + item?.length}
                            className="text-text15 font-[400] leading-5"
                          >
                            {item}
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
              {inactivityErrorMsg?.status !== undefined &&
                [404, 500, 403, 422, 401].includes(
                  Number(inactivityErrorMsg.status)
                ) && (
                  <div className="mb-5 mt-5">
                    <InlineError
                      errorText={inactivityErrorMsg.detail}
                      aria-live="assertive"
                      fontSize={'text-[15px]'}
                      onClose={() => setInactivityErrorMsg(null)}
                      oncloseHide={true}
                    />
                  </div>
                )}
              <span>
                {changePin?.newFourDigitPin}{' '}
                {accountDetails?.customer?.cardLast4}
              </span>

              {/* New PIN Input */}
              <div className="mt-5">
                <PasswordInput
                  label={changePin?.enterNewPin}
                  ariaLabel={changePin?.enterNewPin}
                  placeHolder={changePin?.enterNewPin_palceHolder}
                  maxLength={4}
                  {...register('newPin', {
                    required: `${changePin?.enterNewPin_palceHolder}`,
                    validate: {
                      isFourDigits: (value) =>
                        /^[0-9]{4}$/.test(value) ||
                        `${changePin?.pinDoesNotMeet}`,
                      // noLeadingZero: (value) =>
                      //   !value.startsWith('0') ||
                      //   `${
                      //     changePin?.tooltip?.descriptionWeb?.split('\n•')?.[2]
                      //   }`,
                    },
                    // pattern: {
                    //   value: /^[0-9]{4}$/,
                    //   message: 'PIN must be exactly 4 digits and numeric',
                    // },
                  })}
                  error={
                    errors.newPin?.message && (
                      <span className="flex items-center gap-[7px]">
                        <BalanceIcon fill="#DA291C" />
                        {errors.newPin?.message}
                      </span>
                    )
                  }
                  showClearButton={!!newPinValue}
                />
              </div>

              {/* Confirm PIN Input */}
              <div className="mt-5">
                <PasswordInput
                  label={changePin?.confirmNewPin}
                  ariaLabel={changePin?.confirmNewPin}
                  placeHolder={changePin?.confirmNewPin_palceHolder}
                  maxLength={4}
                  {...register('confirmPin', {
                    required: `${changePin?.confirmNewPin_palceHolder}`,
                    pattern: {
                      value: /^[0-9]{4}$/, // Only 4-digit numbers allowed
                      message: `${changePin?.pinDoesNotMeet}`,
                    },
                    validate: (value) =>
                      value === newPinValue ||
                      `${changePin?.enterdPasswordDoNotMatch}`,
                  })}
                  error={
                    errors.confirmPin?.message && (
                      <span className="flex items-center gap-[7px]">
                        <BalanceIcon fill="#DA291C" />
                        {errors.confirmPin?.message}
                      </span>
                    )
                  }
                  showClearButton={!!newPinValue}
                />
              </div>

              <div className="flex flex-1 flex-col mt-7 mb-7">
                <div
                  className="flex flex-col gap-2 p-6 bg-[#F1FDFF] rounded-lg w-full h-auto"
                  aria-labelledby="important-info"
                >
                  <h4
                    id="important-info"
                    className="text-lg font-semibold text-gray-800"
                    aria-label={changePin?.setupInstructionsTitle}
                  >
                    {changePin?.setupInstructionsTitle}
                  </h4>
                  <ul className="list-disc font-normal text-[14px] text-gray-700 px-6">
                    {changePin.setupInstructions
                      ? Object.values(changePin.setupInstructions).map(
                          (item: any, index: number) => (
                            <li key={index + item?.length}>{item}</li>
                          )
                        )
                      : null}
                  </ul>
                </div>
              </div>

              {/* Submit Button */}
              <div className="flex gap-2 md:relative fixed bottom-0 left-0 p-5 md:p-0 border md:bt-none bt-[#E9E9E9] bg-[#FAFAFA] md:bg-white w-full ">
                <button
                  type="button"
                  aria-label={changePin?.cancel}
                  onClick={onCloseIconClick}
                  className="min-h-[48px] w-full h-10 bg-white hover:bg-red-50 text-primary-red font-medium py-2 px-4 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 border border-1 border-primary-red"
                  // onKeyDown={(e) => {
                  //   if (e.key === 'Enter') {
                  //     onCloseIconClick();
                  //   }
                  // }}
                >
                  {changePin?.cancel}
                </button>
                <div className="relative w-full">
                  <SubmitButton
                    text={loading ? '' : changePin?.submit}
                    disabled={!isValid}
                    loader={loading}
                    aria-busy={loading}
                  />
                  {loading && (
                    <div className="flex justify-center items-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                      <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-6 w-6"></div>
                    </div>
                  )}
                </div>
              </div>
            </form>
            <div
              className="absolute top-5 right-5"
              onClick={onCloseIconClick}
              data-testid="closeIcon"
            >
              <CloseIcon width={'24'} height="24" fill="#1F1F1F" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChangePinAndActivateCardModal;
